import { envConfig, isProd } from "@configs/env";
import { DeployEnv } from "@types";
import { useEffect, useMemo, useState } from "react";

type ServerConfig = {
  underMaintenance: boolean;
};

export const useUnderMaintenance = () => {
  const [serverConfig, setServerConfig] = useState<ServerConfig | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    if (envConfig.deploymentEnv === DeployEnv.Local) return;
    const group = envConfig.brand.group;
    const accountId = envConfig.accountId;
    const env = envConfig.deploymentEnv;
    const queryToken = new Date().getTime();

    let overrideUnderMaintenance = false;
    if (!isProd() && localStorage.getItem("ENABLE_MAINTENANCE_DEV") === "true") {
      overrideUnderMaintenance = true;
    }

    // check group config first
    // if group is under maintenance, no need to check account config
    fetch(`https://raw.githubusercontent.com/99techteam/kz-config/main/groups/${group}/${env}.json?t=` + queryToken, {
      cache: "no-store",
    })
      .then((res) => res.json())
      .then((data) => {
        const isGroupUnderMaintenance = data.underMaintenance;
        if (isGroupUnderMaintenance) {
          setServerConfig({
            underMaintenance: true,
          });
          setIsLoading(false);
        } else {
          fetch(
            `https://raw.githubusercontent.com/99techteam/kz-config/main/groups/${group}/${accountId}.${env}.json?t=` +
              queryToken,
            {
              cache: "no-store",
            },
          )
            .then((res) => res.json())
            .then((data) => {
              setServerConfig({
                underMaintenance: overrideUnderMaintenance || data.underMaintenance,
              });
            })
            .finally(() => {
              setIsLoading(false);
            });
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, []);

  const underMaintenance = useMemo(() => {
    return serverConfig?.underMaintenance ?? import.meta.env.VITE_MAINTENANCE === "true";
  }, [serverConfig]);

  return { underMaintenance, isLoading };
};
